import { useState } from "react";
import axios from "axios";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import Spinner from "../components/Spinner";
import { API_HOST as SERVICES_API_BASE_URL } from "../api/brandingApi";

const API_URL = `${SERVICES_API_BASE_URL}/api/auth`;

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    try {
      const res = await axios.post(`${API_URL}/login`, {
        email,
        password,
      });
      login(res.data.token);
      navigate("/");
    } catch (err: any) {
      setError(typeof err.response?.data === 'string' ? err.response.data : "Invalid email or password. Please try again.");
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className="w-full max-w-md p-8 card bg-white shadow-xl border border-slate-200 animate-fade-in">
      {/* Logo & Header */}
      <div className="text-center mb-8">
        <div className="inline-flex items-center justify-center w-12 h-12 bg-gradient-to-br from-blue-400 to-indigo-600 rounded-xl mb-4 shadow-lg shadow-blue-200">
          <span className="text-white font-bold text-xl">S</span>
        </div>
        <h1 className="text-3xl font-bold text-slate-900">Strivre Services</h1>
        {/* <p className="text-slate-500 mt-2">Sign in to access your dashboard</p> */}
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-semibold text-slate-700 mb-1" htmlFor="email">
            Email Address
          </label>
          <input
            id="email"
            type="email"
            placeholder="name@company.com"
            value={email}
            onChange={e => setEmail(e.target.value)}
            className="input-base w-full"
            disabled={isLoading}
            required
          />
        </div>

        <div>
          <label className="block text-sm font-semibold text-slate-700 mb-1" htmlFor="password">
            Password
          </label>
          <input
            id="password"
            type="password"
            placeholder="••••••••"
            value={password}
            onChange={e => setPassword(e.target.value)}
            className="input-base w-full"
            disabled={isLoading}
            required
          />
        </div>

        {error && (
          <div className="p-3 bg-red-50 border border-red-100 text-red-600 text-sm rounded-lg animate-shake">
            {error}
          </div>
        )}

        <button 
          type="submit" 
          disabled={isLoading}
          className="btn-primary w-full py-3 flex items-center justify-center gap-2"
        >
          {isLoading ? (
            <>
              <Spinner size="h-5 w-5" />
              Signing in...
            </>
          ) : "Sign In"}
        </button>
      </form>

      <div className="relative my-8">
        <div className="absolute inset-0 flex items-center">
          <span className="w-full border-t border-slate-200"></span>
        </div>
        <div className="relative flex justify-center text-xs uppercase">
          <span className="bg-white px-2 text-slate-400">Or continue with</span>
        </div>
      </div>

      <div className="space-y-3">
        <button className="btn-secondary w-full py-2.5">Google</button>
        <button className="btn-secondary w-full py-2.5">Microsoft 365</button>
      </div>
    </div>
  );
}
